// extracted by mini-css-extract-plugin
export default {"layout":"Manager_layout__8IPpg","banner":"Manager_banner__4+M8R","container":"Manager_container__+DSje","grid":"Manager_grid__1mE8i","title":"Manager_title__D9vo8"};